export default {
  Actions: {
    FETCH_REVIEW_TEMPLATES_SUCCESS: 'reviews/FETCH_REVIEW_TEMPLATES_SUCCESS',
    FETCH_REVIEW_TEMPLATE_SUCCESS: 'reviews/FETCH_REVIEW_TEMPLATE_SUCCESS',
    DUPLICATE_REVIEW_TEMPLATE_SUCCESS: 'reviews/DUPLICATE_REVIEW_TEMPLATE_SUCCESS',
    CREATE_REVIEW_TEMPLATE_SUCCESS: 'reviews/CREATE_REVIEW_TEMPLATE_SUCCESS',
    UPDATE_REVIEW_TEMPLATE_SUCCESS: 'reviews/UPDATE_REVIEW_TEMPLATE_SUCCESS',
    DELETE_REVIEW_TEMPLATE_SUCCESS: 'reviews/DELETE_REVIEW_TEMPLATE_SUCCESS',
  },
  State: {
    REVIEWS_TEMPLATES_BY_SLUG: 'REVIEWS_TEMPLATES_BY_SLUG',
  },
};
